import { AppBar, Toolbar, Box, IconButton, Typography } from '@mui/material'
import { Link } from '@tanstack/react-router'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { getDisplayName } from '@/auth/authHelpers'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'

export function AppHeader() {
  const isAuthenticated = useIsAuthenticated()
  const { instance, accounts } = useMsal()

  const handleLogout = () => {
    void instance.logoutRedirect({ postLogoutRedirectUri: '/login' })
  }

  return (
    <AppBar position="sticky" component="header">
      <Toolbar sx={{ gap: 1 }}>
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            flexGrow: 1,
          }}
        >
          <Box
            component="img"
            src="/i4talentLogo.svg"
            alt="i4talent"
            sx={{ height: 36 }}
          />
        </Box>

        {isAuthenticated && (
          <>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              {getDisplayName(accounts[0] ?? null)}
            </Typography>
            <IconButton
              component={Link}
              to="/profile"
              aria-label="Mijn profiel"
              size="small"
            >
              <AccountCircleIcon />
            </IconButton>
            <IconButton onClick={handleLogout} aria-label="Uitloggen" size="small">
              <LogoutIcon />
            </IconButton>
          </>
        )}
      </Toolbar>
    </AppBar>
  )
}